import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { telemetry } from '../../../../services/backend';
import { getMemberAlerts } from '../../../../services/member/alerts';
import { selectCurrentMemberId } from '../../../../services/store/modules/backend-service';
import useNotifications from './use-notifications';

/** Total of active alerts plus notifications, as shown on the alerts badge. */
const useAlertsCount = (): number => {
  const currentMemberId = useSelector(selectCurrentMemberId);
  const [, , , , notificationCount] = useNotifications();
  const [alertsCount, setAlertsCount] = useState(0);

  useEffect(() => {
    let isMounted = true;

    const checkActiveAlerts = async () => {
      try {
        const { activeAlerts } = await getMemberAlerts();
        telemetry(
          telemetry.DEBUG,
          `[useAlertsCount.checkActiveAlerts] received alerts: ${JSON.stringify(
            activeAlerts,
          )}`,
        );
        if (isMounted) setAlertsCount(activeAlerts?.length || 0);
      } catch (err) {
        telemetry(
          telemetry.ERROR,
          `[useAlertsCount.checkActiveAlerts] Error retrieving ${JSON.stringify(
            err,
          )}`,
        );
      }
    };
    if (currentMemberId) {
      checkActiveAlerts();
    }

    return () => {
      isMounted = false;
    };
  }, [currentMemberId, notificationCount]);

  return alertsCount + (notificationCount ?? 0);
};

export default useAlertsCount;
